/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsLogUpload
 */
export interface MelcoModelsLogUpload {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLogUpload
     */
    category?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLogUpload
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLogUpload
     */
    file_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLogUpload
     */
    device_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLogUpload
     */
    base64_file?: string | null;
}

export function MelcoModelsLogUploadFromJSON(json: any): MelcoModelsLogUpload {
    return MelcoModelsLogUploadFromJSONTyped(json, false);
}

export function MelcoModelsLogUploadFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsLogUpload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'category': !exists(json, 'category') ? undefined : json['category'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'file_name': !exists(json, 'file_name') ? undefined : json['file_name'],
        'device_name': !exists(json, 'device_name') ? undefined : json['device_name'],
        'base64_file': !exists(json, 'base64_file') ? undefined : json['base64_file'],
    };
}

export function MelcoModelsLogUploadToJSON(value?: MelcoModelsLogUpload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'category': value.category,
        'description': value.description,
        'file_name': value.file_name,
        'device_name': value.device_name,
        'base64_file': value.base64_file,
    };
}


